// Tour persistence service (localStorage-based)

export type TourStatus = 'not_started' | 'in_progress' | 'completed' | 'dismissed';

export interface TourState {
  status: TourStatus;
  lastStep: number;
  completedAt: string | null;
  completedSteps: number[];
}

const TOUR_KEY = 'hostvsl_first_steps_tour';

const DEFAULT_STATE: TourState = {
  status: 'not_started',
  lastStep: 0,
  completedAt: null,
  completedSteps: [],
};

export function getTourState(): TourState {
  try {
    const raw = localStorage.getItem(TOUR_KEY);
    if (!raw) return { ...DEFAULT_STATE };
    return { ...DEFAULT_STATE, ...JSON.parse(raw) };
  } catch {
    return { ...DEFAULT_STATE };
  }
}

export function setTourState(partial: Partial<TourState>): TourState {
  const current = getTourState();
  const next = { ...current, ...partial };
  localStorage.setItem(TOUR_KEY, JSON.stringify(next));
  return next;
}

export function resetTour(): TourState {
  localStorage.setItem(TOUR_KEY, JSON.stringify(DEFAULT_STATE));
  return { ...DEFAULT_STATE };
}

export function markStepCompleted(stepIndex: number): TourState {
  const current = getTourState();
  const completedSteps = current.completedSteps.includes(stepIndex)
    ? current.completedSteps
    : [...current.completedSteps, stepIndex];
  return setTourState({ completedSteps, lastStep: stepIndex });
}
